import {Tracker} from '@udemy/event-tracking';
import {
    type CertificationVoucher,
    CertificationVoucherOfferPresented,
    CertificationVoucherOfferSelected,
    VoucherUIRegion,
} from '@udemy/react-certification-preparation';
import {CertificationVoucherBuyable} from '@udemy/shopping';

export const UPSELL_VOUCHER_UI_REGION = 'cart_upsell' as VoucherUIRegion;

export function toCertVoucher(buyable: CertificationVoucherBuyable): CertificationVoucher {
    return {
        name: buyable.title,
        examId: buyable.offer_id ?? null,
        poolId: String(buyable.id),
        voucherId: null,
    };
}

export function trackUpsellVoucherOfferPresented(buyable: CertificationVoucherBuyable): void {
    Tracker.publishEvent(
        new CertificationVoucherOfferPresented({
            uiRegion: UPSELL_VOUCHER_UI_REGION,
            certVoucher: toCertVoucher(buyable),
        }),
    );
}

export function trackUpsellVoucherOfferSelected(buyable: CertificationVoucherBuyable): void {
    Tracker.publishEvent(
        new CertificationVoucherOfferSelected({
            uiRegion: UPSELL_VOUCHER_UI_REGION,
            certVoucher: toCertVoucher(buyable),
        }),
    );
}
